export default "__VITE_ASSET__Xh0UvYF8__"